import React from "react";

import Card from "@material-ui/core/Card";
import { Grid } from "@material-ui/core";
import Box from '@mui/material/Box';
import TheaterComedyOutlinedIcon from '@mui/icons-material/TheaterComedyOutlined';
import IconButton from '@mui/material/IconButton';
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
import EditRoundedIcon from '@mui/icons-material/EditRounded';
import ArchiveRoundedIcon from '@mui/icons-material/ArchiveRounded';
import UnarchiveRoundedIcon from '@mui/icons-material/UnarchiveRounded';
import Tooltip from '@mui/material/Tooltip';
import LinkIcon from '@mui/icons-material/Link';
import VisibilityRoundedIcon from '@mui/icons-material/VisibilityRounded';
import LinearProgress from '@mui/material/LinearProgress';

import Style from "../../../../styles/js/Styles";
import * as Constants from "../../../../consts/Constants.js";
import Image from "../../../utils/image";
import ImageViewer from "../../../utils/image-viewer"
import service from '../../../../plas/services/ads/service';
import { Range } from "../../../../plas/utils/times/models"

function AdvertisementItem({ advertisement, onDelete, canEdit, onEdit, onOpen, onArchive, onUnarchive, disable, updating}) {

  const style = Style();

  const ColoredLine = ({ color }) => (
      <hr
          style={{
              color: color,
              backgroundColor: color,
              marginTop: 0,
              marginBottom: 12,
              height: 1
          }}
      />
  );

  const [blobUrl, setBlobUrl] = React.useState(null);

  const closeImage = () => {
    setBlobUrl(null);
  }

  const openUrl = () => {
    var win = window.open(advertisement.url, '_blank');
    win.focus();
  }

  return (
    <Grid container spacing={0}>
      <Grid item xs={12}>
        <p style={{ marginTop: 8, marginBottom: 4, fontSize: 17, color: 'gray', textAlign: 'left'}}>
          { new Range(advertisement.startDate, advertisement.endDate).asDateText() }
        </p>
      </Grid>
      <Grid item xs={12}>
        <Card elevation={0} >
          { updating ? (<LinearProgress />) : (<div style={{height: 4}}/>)}
          <Card style={{ textAlign: 'left', marginBottom: 8 }}>
            <Grid container spacing={2}>
              <Grid item xs={true}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Grid container spacing={2}>
                      <Grid item>
                        <Box
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          height="100%"> 
                            { advertisement.binId ? (
                              <Card elevation={0}>
                                <Image 
                                  onClick={(url) => { setBlobUrl(url) }}
                                  url={service.api.advertisements.getMediaUrl(advertisement.id,advertisement.binId)} 
                                  containerProps={{style:{height: '100%'}}}
                                  imgProps={{ className: style.selectable, style:{ width: 150, maxHeight: 251, objectFit: 'contain', height: '100%'}}}
                                />
                              </Card>) : (
                                <Card elevation={0} style={{height: '100%'}}>
                                  <TheaterComedyOutlinedIcon style={{ width: 150, background: Constants.COLOR_PRIMARY_LIGHT, color: 'white', padding: 8, 'objectFit': 'contain', height: '100%'}}/>
                                </Card>
                              )
                            }                          
                        </Box>
                      </Grid>
                      <Grid item xs={true}>
                        <Grid container style={{ paddingRight: '16px'}}>
                          <Grid item xs={true}>
                            <p className={style.ellipseableText} style={{ 'WebkitLineClamp': 2, paddingTop: 12, marginBottom: '0.4rem', fontSize: 16, color: '#6C6C6C', textAlign: 'left'}}>
                              <b>{advertisement.title}</b>
                            </p>
                          </Grid>
                          <Grid item>
                            <div style={{paddingTop: 4}}>
                              { advertisement.url && 
                                (<Tooltip title="Abrir URL">
                                  <span>
                                    <IconButton disabled={disable} onClick={openUrl}>
                                      <LinkIcon fontSize="small"/>
                                    </IconButton>
                                  </span>
                                </Tooltip>)
                              }
                              <Tooltip title="Ver">
                                <span>
                                  <IconButton disabled={disable} onClick={() => {onOpen(advertisement)}}>
                                    <VisibilityRoundedIcon fontSize="small"/>
                                  </IconButton>
                                </span>
                              </Tooltip>
                              { canEdit && (
                                <Tooltip title="Editar">
                                <span>
                                  <IconButton disabled={disable} onClick={() => { onEdit(advertisement) }}>
                                    <EditRoundedIcon fontSize="small"/>
                                  </IconButton>
                                </span>
                              </Tooltip>
                              )}
                              { canEdit && advertisement.state === 0 ? (
                                <Tooltip disabled={disable} title="Archivar">
                                  <span>
                                    <IconButton onClick={() => { onArchive(advertisement) }}>
                                      <ArchiveRoundedIcon fontSize="small"/>
                                    </IconButton>
                                  </span>
                                </Tooltip>) : (
                                <>
                                  { canEdit && (
                                    <>
                                      <Tooltip disabled={disable} title="Desarchivar">
                                        <span>
                                          <IconButton onClick={() => { onUnarchive(advertisement) }}>
                                            <UnarchiveRoundedIcon fontSize="small"/>
                                          </IconButton>
                                        </span>
                                      </Tooltip>
                                      <Tooltip disabled={disable} title="Eliminar">
                                        <span>
                                          <IconButton onClick={() => { onDelete(advertisement) }}>
                                            <DeleteRoundedIcon fontSize="small"/>
                                          </IconButton>
                                        </span>
                                      </Tooltip>
                                    </>
                                  )}
                                </>
                              )}
                            </div>
                          </Grid>
                          <Grid item xs={12}>
                            <ColoredLine />
                          </Grid>
                          <Grid item xs={12} style={{marginBottom: 53}}>
                            <p className={style.ellipseableText} style={{ 'WebkitLineClamp': 4, marginBottom: 0, fontSize: 15, color: 'black', textAlign: 'left' }}>
                              <i>{advertisement.body}</i>
                            </p>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12} style={{ marginTop: -69, marginLeft: 150, marginRight: 12}}>
                    <p style={{ marginBottom: 8, textAlign:"end", fontSize: 15, color: 'gray'}}>
                      <span
                        style={{ 'WebkitLineClamp': 1, paddingRight: 4 }} 
                        className={style.ellipseableText}>
                        {advertisement.place.name}
                      </span>
                      <i 
                        style={{ 'WebkitLineClamp': 1, paddingRight: 4 }} 
                        className={style.ellipseableText}>
                        {advertisement.place.address}
                      </i>
                    </p>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Card>
        </Card>
      </Grid>

      <ImageViewer open={blobUrl? true : false} url={blobUrl} onClose={closeImage} />

    </Grid>
  );

}

export default AdvertisementItem;
